import type { useSingleton } from "@tippyjs/react";
import { useTranslation } from "react-i18next";
import { canv } from "@/canv/global";
import { MultiplayerCursorsIcon } from "@/icons";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { Tooltip } from "@/interface/ui/Tooltip";

type Props = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    disableMultiCursors: boolean;
    className?: string;
};

export const MultiplayerCursors = ({ singletoneTarget, disableMultiCursors, className }: Props) => {
    const { t } = useTranslation();
    const setDisableMultiCursors = () =>
        canv.multiManager.setDisableMultiCursors(!disableMultiCursors);
    return (
        <Tooltip
            singleton={singletoneTarget}
            content={disableMultiCursors ? t("header.showCursors") : t("header.hideCursors")}
        >
            <BottomBarItem
                className={className}
                active={!disableMultiCursors}
                onClick={setDisableMultiCursors}
            >
                <MultiplayerCursorsIcon />
            </BottomBarItem>
        </Tooltip>
    );
};
